import React, { useState } from "react";
import { Card } from "@material-tailwind/react";
import toast from "react-hot-toast";

export default function HigherEducationPopUp({
  closeModal,
  handleAddEducationDetails,
  exam_name,
  institute_name,
  document,
}) {
  const [formData, setFormData] = useState({
    exam_name: exam_name || "",
    institute_name: institute_name || "",
    document: document || null,
  });

  const [file, setFile] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false); // Add this state

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validation
    if (
      !formData.exam_name ||
      !formData.institute_name ||
      (!file && !document)
    ) {
      toast.error("Please fill in all required fields");
      return;
    }

    setIsSubmitting(true); // Disable button
    try {
      await handleAddEducationDetails(formData, file);
    } finally {
      setIsSubmitting(false); // Re-enable button
    }
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-80 z-50">
      <Card
        color="transparent"
        shadow={false}
        className="w-[90%] max-w-[700px] max-h-[90vh] bg-gray-900 rounded-[20px] overflow-hidden flex flex-col"
      >
        <div className="overflow-y-auto flex-1 p-6">
          <form
            onSubmit={handleSubmit}
            className="text-white flex flex-col space-y-6"
          >
            {/* Exam Name */}
            <div className="relative z-0 w-full group">
              <label htmlFor="exam_name" className="block text-sm">
                Exam Name <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                name="exam_name"
                className="block py-3 px-4 w-full text-sm bg-gray-800 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                required
                onChange={handleChange}
                value={formData.exam_name}
              />
            </div>

            {/* Institute Name */}
            <div className="relative z-0 w-full group">
              <label htmlFor="institute_name" className="block text-sm">
                Institute Name <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                name="institute_name"
                className="block py-3 px-4 w-full text-sm bg-gray-800 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                required
                onChange={handleChange}
                value={formData.institute_name}
              />
            </div>

            {/* Document Upload */}
            <div className="relative z-0 w-full group">
              <label htmlFor="document" className="block text-sm">
                Upload Document <span className="text-red-500">*</span>
              </label>
              <input
                type="file"
                name="document"
                accept=".pdf"
                className="block py-3 px-4 w-full text-sm bg-gray-800 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                required={!document}
                onChange={handleFileChange}
              />
              <p className="text-xs text-red-400 mt-1">
                Note: Provide document proof of admission Ex - Admission letter,
                Exam score card etc
              </p>
              {document && !file && (
                <a
                  href={`${process.env.REACT_APP_BACKEND_URL}/${document}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-xs text-blue-400 underline mt-1 block"
                >
                  Current file: {document.split("/").pop()}
                </a>
              )}
            </div>

            <p className="text-sm text-gray-400">
              <span className="text-red-500">*</span> compulsory fields
            </p>

            <div className="flex items-center justify-between mt-5 space-x-4">
              <button
                type="submit"
                className="w-full px-6 py-3 bg-blue-500 text-white rounded-lg hover:bg-blue-600 disabled:opacity-50 disabled:cursor-not-allowed"
                disabled={isSubmitting}
              >
                {isSubmitting ? "Saving..." : "Save"}
              </button>
              <button
                type="button"
                onClick={closeModal}
                className="w-full px-6 py-3 bg-gray-500 text-white rounded-lg hover:bg-gray-600"
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      </Card>
    </div>
  );
}
